import { styled } from '@slal/ui';
import { InputGroup } from '@slal/ui/forms';
import { breakpointUp } from '@slal/ui/helpers';
import { P } from '@slal/ui/typography';

type StyledTotalAllocationProps = {
    hasError?: boolean;
};

export const StyledRow = styled('div')`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 28px;
    align-items: center;
    padding: 14px 0;
    border-bottom: ${({ theme }) => `1px solid ${theme.colors.neutral__light__30}`};

    &:first-child {
        border-bottom: none;
        padding-bottom: 0;
    }
    &.last-row {
        border-bottom: none;
    }
`;

export const AllocationInputGroup = styled(InputGroup)`
    display: flex;
    align-items: center;

    > div {
        flex: none;
    }

    input {
        width: 60px;
        padding: 0 10px;

        ${breakpointUp.md`
            width: 80px;
            padding: 8px 16px;
        `}
    }
    label[aria-disabled='true'] {
        color: ${({ theme }) => theme.colors.neutral__light__40};
        cursor: not-allowed;
    }
`;

export const CheckboxWrapper = styled('div')`
    display: flex;
    align-items: flex-start;
    gap: 14px;
    max-width: 100%;
`;

export const StyledFundDetails = styled('div')``;

export const StyledParagraph = styled(P)`
    flex: 1;
    max-width: 150px;
    font-size: ${({ theme }) => theme.fontSizes[3]};
    padding-bottom: ${({ theme }) => theme.space[3]};
    ${breakpointUp.lg`
        max-width: 100%;
        font-size: ${({ theme }) => theme.fontSizes[4]};
    `}
`;

export const StyledTotalAllocation = styled('div')<StyledTotalAllocationProps>`
    width: 100%;
    padding: 16px 10px;
    margin-top: 10px;
    margin-bottom: 14px;
    background-color: ${({ theme }) => theme.colors.neutral__light__10};
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: none;
    border-radius: ${({ theme }) => theme.borderRadius.medium};

    ${breakpointUp.lg`
        width: 450px;
        padding: 16px 10px;
    `}

    h4 {
        margin-bottom: 0;
    }
`;
